import { ApiProperty } from '@nestjs/swagger'
import { ProficiencyLevel } from '../../../enums'

/**
 * DTO for Program Competency response
 */
export class ProgramCompetencyDto {
  @ApiProperty({
    description: 'Program Competency UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  id: string

  @ApiProperty({
    description: 'Program Version UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  programVersionId: string

  @ApiProperty({
    description: 'Competency UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  competencyId: string

  @ApiProperty({
    description: 'Expected proficiency level',
    enum: ProficiencyLevel,
    example: 'CONSOLIDATE',
  })
  expectedLevel: ProficiencyLevel

  @ApiProperty({
    description: 'Whether this is a key competency',
    example: false,
  })
  isKey: boolean

  @ApiProperty({
    description: 'Order in program',
    example: 1,
    required: false,
  })
  orderInProgram?: number

  @ApiProperty({
    description: 'Creation timestamp',
    example: '2024-01-01T00:00:00.000Z',
  })
  createdAt: Date

  @ApiProperty({
    description: 'Last update timestamp',
    example: '2024-01-01T00:00:00.000Z',
  })
  updatedAt: Date
}
